import React, { useContext } from "react";
import FixelDataContext from "../../../context/FixelDataContext";
import Notification from "./notificationSubComponents/Notification";
import PotentialGain from "./potentialGain/PotentialGainNotification";
import ProgressBarNotification from "./progressBar/ProgressBarNotification";
import * as genNotifications from "./generateNotificationContent";
import * as shouldNotify from "./shouldDisplayNotification";
import { useHistory } from "react-router-dom";
import { StyledNotificationContainer } from "./notifications.style";

const Notifications = () => {
  const history = useHistory();
  const { fullFixelData } = useContext(FixelDataContext);
  return (
      <StyledNotificationContainer>
        {shouldNotify.showTrialUnder7Days(fullFixelData) && (
            <Notification
                type="info"
                content={genNotifications.TrialNearEnd(fullFixelData.plan.trial_days_remaining)}
                CTA={() => {
                  return history.push("/plans");
                }}
            />
        )}
        {shouldNotify.showTrialExpired(fullFixelData) && (
            <Notification
                type="warning"
                content={genNotifications.TrialOver()}
                CTA={() => {
                  return history.push("/plans");
                }}
            />
        )}
        {shouldNotify.showNoActivePlan(fullFixelData) && (
            <Notification
                type="warning"
                content={genNotifications.NoPlan()}
                CTA={() => {
                  history.push("/plans");
                }}
            />
        )}
        {shouldNotify.showIntegrationFailure(fullFixelData) && (
            <Notification
                type="warning"
                content={genNotifications.IntegrationFailure("Facebook")}
                CTA={() => {
                  return history.push("/setup/facebook");
                }}
                onDismiss={() => {
                  return localStorage.setItem("alertedFBIntegrationFailure", fullFixelData.code);
                }}
            />
        )}
        {shouldNotify.showFBIntegrationSuccessful(fullFixelData) && (
            <Notification
                type="success"
                content={genNotifications.IntegrationSuccess("Facebook")}
                CTA={() => {
                  return localStorage.setItem("alertedFBIntegrationSuccessful", fullFixelData.code);
                }}
                onDismiss={() => {
                  return localStorage.setItem("alertedFBIntegrationSuccessful", fullFixelData.code);
                }}
            />
        )}
        {shouldNotify.showSegmentActive(fullFixelData) && (
            <Notification
                type="success"
                content={genNotifications.SegmentActive("Facebook")}
                CTA={() => {
                  return localStorage.setItem("alertedSegmentActive", fullFixelData.code);
                }}
                onDismiss={() => {
                  return localStorage.setItem("alertedSegmentActive", fullFixelData.code);
                }}
            />
        )}
        {shouldNotify.showAnalyzeProgressBar(fullFixelData) && (
            <ProgressBarNotification
                content={genNotifications.noStatsContent(
                    fullFixelData.LAST_30_DAYS.fixelStats.total,
                    500,
                )}
                type="noStats"
            />
        )}
        {shouldNotify.showPotentialRevenue(fullFixelData) && <PotentialGain />}
      </StyledNotificationContainer>
  );
};
export default Notifications;